/**
 * Builds PDP collection-layers tabs/panels from product metafield data.
 * Used by custom-product and simple-dual-product.
 */
(function () {
  var rebuildToken = 0;

  var PDP_LAYER_DEFAULT_PIN_POS = [
    null,
    { top: 15, left: 62 },
    { top: 23, left: 60 },
    { top: 35, left: 58 },
    { top: 42, left: 56 },
    { top: 52, left: 44 },
    { top: 50, left: 65 },
    { top: 70, left: 63 },
    { top: 78, left: 52 },
    { top: 84, left: 58 },
    { top: 90, left: 49 }
  ];

  function normalizeLabel(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function escapeRegExp(str) {
    return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getProductTabLabel(productItem, collectionTitle, collectionHandle) {
    if (!productItem) return '';
    if (productItem.tabsMainHeading) return normalizeLabel(productItem.tabsMainHeading);
    if (productItem.firmnessTabLabel) return normalizeLabel(productItem.firmnessTabLabel);
    if (productItem.tabLabel) return normalizeLabel(productItem.tabLabel);

    var title = normalizeLabel(productItem.title);
    if (!title) return normalizeLabel(productItem.handle);

    var prefixes = [];
    var seen = {};

    function addPrefix(value) {
      var p = normalizeLabel(value);
      if (!p) return;
      var key = p.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      prefixes.push(p);
    }

    addPrefix(collectionTitle);
    if (collectionHandle) {
      addPrefix(collectionHandle);
      var handle = collectionHandle.toLowerCase();
      if (handle === 'flamenco') {
        addPrefix('Flamenco');
        addPrefix('Moderno');
        addPrefix('Modreno');
      } else if (handle === 'tango') {
        addPrefix('Classico');
        addPrefix('Tango');
      }
    }

    ['Classico', 'Flamenco', 'Tango', 'Moderno', 'Modreno', 'Suave'].forEach(addPrefix);
    prefixes.sort(function (a, b) {
      return b.length - a.length;
    });

    var stripped = title;
    var i;
    for (i = 0; i < prefixes.length; i++) {
      var pattern = new RegExp(
        '^' + escapeRegExp(prefixes[i]) + '\\s*[-–—|:·•]?\\s*',
        'i'
      );
      if (pattern.test(stripped)) {
        stripped = stripped.replace(pattern, '').trim();
      }
    }

    return stripped || title;
  }

  function resolveImageUrl(productItem) {
    if (!productItem) return '';
    var tabsImage = productItem.tabsImage;
    if (tabsImage != null && String(tabsImage).trim() && String(tabsImage).trim() !== 'null') {
      return String(tabsImage).trim();
    }
    if (productItem.image && String(productItem.image).trim() && String(productItem.image).trim() !== 'null') {
      return String(productItem.image).trim();
    }
    return '';
  }

  function resolveIntro(productItem, collectionIntro) {
    if (productItem && productItem.tabsDescription != null) {
      var tabsDesc = String(productItem.tabsDescription).trim();
      if (tabsDesc && tabsDesc !== 'null') {
        return normalizeLabel(tabsDesc);
      }
    }
    return normalizeLabel(collectionIntro);
  }

  function resolveHeading(productItem, headingFallback) {
    if (productItem && productItem.tabsHeading != null) {
      var heading = String(productItem.tabsHeading).trim();
      if (heading && heading !== 'null') {
        return normalizeLabel(heading);
      }
    }
    return normalizeLabel(headingFallback);
  }

  function parsePinPercent(value, fallback) {
    if (value == null || value === '' || value === 'null') return fallback;
    var n = parseFloat(String(value).replace('%', '').trim());
    if (isNaN(n)) return fallback;
    return Math.max(0, Math.min(100, n));
  }

  function resolvePinPosition(productItem, pinIndex) {
    var defPos = PDP_LAYER_DEFAULT_PIN_POS[pinIndex] || { top: 15, left: 62 };
    var entry = null;
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      entry = productItem.tabsLayers[pinIndex - 1] || null;
    }
    return {
      top: parsePinPercent(entry ? entry.pinTop : null, defPos.top),
      left: parsePinPercent(entry ? entry.pinLeft : null, defPos.left)
    };
  }

  function resolveLayerContent(productItem) {
    var layers = [];
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      productItem.tabsLayers.forEach(function (entry) {
        if (!entry) return;
        var q = normalizeLabel(entry.q);
        var a = normalizeLabel(entry.a);
        if (!q && !a) return;
        layers.push({
          title: q || 'Layer ' + (layers.length + 1),
          body: a
        });
      });
    }
    return {
      layers: layers,
      pointCount: layers.length ? Math.min(layers.length, 7) : 0
    };
  }

  function buildPanel(productItem, isActive, headingFallback, collectionIntro) {
    var handle = productItem.handle;
    var panel = document.createElement('div');
    panel.className = 'collection-layers-grid collection-layers-tab-panel' + (isActive ? ' is-active' : '');
    panel.id = 'firmness-panel-' + handle;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'firmness-tab-' + handle);
    panel.setAttribute('data-collection-layers', '');
    panel.setAttribute('data-firmness-panel', handle);
    if (!isActive) panel.hidden = true;

    var layerContent = resolveLayerContent(productItem);
    var pointCount = layerContent.pointCount;
    var layers = layerContent.layers;

    var imageWrap = document.createElement('div');
    imageWrap.className = 'collection-layers-image-wrap';

    var imageUrl = resolveImageUrl(productItem);
    var imageAlt = productItem.title || 'Mattress exploded layers';

    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'collection-layers-image';
      img.src = imageUrl;
      img.alt = imageAlt;
      img.width = 1200;
      img.height = 800;
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'collection-layers-image collection-layers-image--placeholder';
      ph.setAttribute('role', 'img');
      ph.setAttribute('aria-label', imageAlt);
      imageWrap.appendChild(ph);
    }

    var pinIndex;
    for (pinIndex = 1; pinIndex <= pointCount; pinIndex++) {
      var pinPos = resolvePinPosition(productItem, pinIndex);
      var pin = document.createElement('button');
      pin.type = 'button';
      pin.className = 'collection-layer-pin' + (pinIndex === 1 && isActive ? ' is-active' : '');
      pin.style.top = pinPos.top + '%';
      pin.style.left = pinPos.left + '%';
      pin.setAttribute('data-layer-pin', String(pinIndex));
      pin.setAttribute('aria-label', 'Show layer ' + pinIndex);
      pin.textContent = String(pinIndex);
      imageWrap.appendChild(pin);
    }
    panel.appendChild(imageWrap);

    var copy = document.createElement('div');
    copy.className = 'collection-layers-copy';

    var titleEl = document.createElement('h3');
    titleEl.className = 'collection-layers-title';
    titleEl.setAttribute('data-pdp-layers-collection-title', '');
    titleEl.textContent = resolveHeading(productItem, headingFallback) || '';
    if (!titleEl.textContent) titleEl.setAttribute('hidden', '');
    copy.appendChild(titleEl);

    var introEl = document.createElement('p');
    introEl.className = 'collection-layers-intro';
    introEl.setAttribute('data-pdp-layers-collection-intro', '');
    introEl.textContent = resolveIntro(productItem, collectionIntro) || '';
    if (!introEl.textContent) introEl.setAttribute('hidden', '');
    copy.appendChild(introEl);

    if (!pointCount) {
      var noData = document.createElement('p');
      noData.className = 'pdp-layers-no-data';
      noData.textContent = 'Layer details are not available for this product yet.';
      copy.appendChild(noData);
      panel.appendChild(copy);
      return panel;
    }

    var list = document.createElement('div');
    list.className = 'collection-layer-list';
    list.setAttribute('role', 'list');

    var layerNum;
    for (layerNum = 1; layerNum <= pointCount; layerNum++) {
      var layerData = layers[layerNum - 1] || {};
      var layerTitle = layerData.title || 'Layer ' + layerNum;
      var layerBody = layerData.body || '';
      var layerOpen = layerNum === 1 && isActive;

      var item = document.createElement('div');
      item.className =
        'collection-layer-item collection-layer-item--accordion' + (layerOpen ? ' is-open' : '');
      item.setAttribute('data-layer-item', String(layerNum));

      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'collection-layer-option' + (layerOpen ? ' is-active' : '');
      opt.setAttribute('data-layer-option', String(layerNum));
      opt.appendChild(document.createTextNode(layerTitle + ' '));

      var caret = document.createElement('span');
      caret.className = 'collection-layer-caret';
      caret.textContent = layerOpen ? '\u25B2' : '\u25BC';
      opt.appendChild(caret);
      item.appendChild(opt);

      var layerPanel = document.createElement('div');
      layerPanel.className = 'collection-layer-panel';
      layerPanel.setAttribute('data-layer-panel', String(layerNum));
      if (layerBody) {
        var body = document.createElement('p');
        body.className = 'collection-layer-body';
        body.textContent = layerBody;
        layerPanel.appendChild(body);
      }
      item.appendChild(layerPanel);
      list.appendChild(item);
    }

    copy.appendChild(list);
    panel.appendChild(copy);
    return panel;
  }

  function buildTabButton(productItem, isActive, collectionTitle, collectionHandle) {
    var handle = productItem.handle;
    var mapLabel = normalizeLabel(productItem.title);
    var tabText = getProductTabLabel(productItem, collectionTitle, collectionHandle) || handle;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-firmness-option' + (isActive ? ' is-active' : '');
    btn.setAttribute('role', 'tab');
    btn.id = 'firmness-tab-' + handle;
    btn.setAttribute('data-firmness-tab', handle);
    btn.setAttribute('data-map-firmness-label', mapLabel);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    btn.setAttribute('aria-controls', 'firmness-panel-' + handle);
    btn.textContent = tabText;
    return btn;
  }

  function getLayersSection() {
    return document.querySelector('[data-pdp-collection-layers-section]');
  }

  function activateTab(section, handle) {
    if (!section || !handle) return;
    var tabBtn = section.querySelector('[data-firmness-tab="' + handle + '"]');
    if (tabBtn) tabBtn.click();
  }

  function setEditorPreviewVisible(visible) {
    var preview = document.querySelector('[data-pdp-layers-editor-preview]');
    if (!preview) return;
    if (visible) {
      preview.removeAttribute('hidden');
    } else {
      preview.setAttribute('hidden', '');
    }
  }

  function rebuild(products, activeHandle, options) {
    options = options || {};
    var layersSection = getLayersSection();
    if (!layersSection) return Promise.resolve(false);

    var tablist = layersSection.querySelector('[data-pdp-layers-tablist]');
    var panelsHost = layersSection.querySelector('[data-pdp-layers-panels]');
    var emptyMsg = layersSection.querySelector('[data-pdp-layers-empty]');
    if (!tablist || !panelsHost) return Promise.resolve(false);

    var token = ++rebuildToken;
    var list = Array.isArray(products) ? products.filter(function (p) { return p && p.handle; }) : [];

    if (!list.length) {
      tablist.innerHTML = '';
      panelsHost.innerHTML = '';
      if (emptyMsg) emptyMsg.hidden = false;
      setEditorPreviewVisible(true);
      return Promise.resolve(false);
    }

    if (emptyMsg) emptyMsg.hidden = true;

    // Do not fall back to editor preview_title (dummy) — only real metafield / options data.
    var collectionTitle = normalizeLabel(options.collectionTitle);
    var headingFallback = collectionTitle;
    var collectionIntro = normalizeLabel(options.collectionIntro);
    var collectionHandle = normalizeLabel(options.collectionHandle);

    var resolvedActive = activeHandle;
    var hasActive = list.some(function (p) {
      return p.handle === resolvedActive;
    });
    if (!hasActive) resolvedActive = list[0].handle;

    tablist.innerHTML = '';
    panelsHost.innerHTML = '';

    var index;
    for (index = 0; index < list.length; index++) {
      if (token !== rebuildToken) return Promise.resolve(false);
      var productItem = list[index];
      var isActive = productItem.handle === resolvedActive;
      tablist.appendChild(buildTabButton(productItem, isActive, headingFallback, collectionHandle));
      panelsHost.appendChild(buildPanel(productItem, isActive, headingFallback, collectionIntro));
    }

    activateTab(layersSection, resolvedActive);
    setEditorPreviewVisible(false);

    document.dispatchEvent(
      new CustomEvent('suave:pdp-layers-rebuilt', {
        detail: {
          activeHandle: resolvedActive,
          productCount: list.length
        }
      })
    );

    return Promise.resolve(true);
  }

  window.SuavePdpLayers = {
    rebuild: rebuild,
    activate: function (handle) {
      activateTab(getLayersSection(), handle);
    },
    getSection: getLayersSection
  };
})();
